/* Career map · UI copy in FR / NL / EN (the map's content is data). */

export const L = (fr, nl, en) => ({ fr, nl, en });
export const COPY = {
  eyebrow:    L('RH · Évolution de carrière', 'HR · Loopbaanontwikkeling', 'HR · Career development'),
  title:      L('Career map', 'Career map', 'Career map'),
  lede:       L('Neuf niveaux, quatre étapes. Explorez ce qui est attendu à chaque niveau, comparez deux niveaux et préparez votre entretien.',
                'Negen niveaus, vier stappen. Bekijk wat er op elk niveau verwacht wordt, vergelijk twee niveaus en bereid je gesprek voor.',
                'Nine levels, four stages. See what each level expects, compare two levels and prepare your review.'),
  draft:      L('Brouillon · visible uniquement par les RH et les admins', 'Concept · alleen zichtbaar voor HR en admins', 'Draft · visible to HR and admins only'),
  published:  L('Publié · visible par toute l’équipe', 'Gepubliceerd · zichtbaar voor het hele team', 'Published · visible to the whole team'),
  publish:    L('Publier', 'Publiceren', 'Publish'),
  unpublish:  L('Dépublier', 'Verbergen', 'Unpublish'),
  confirmPub: L('Publier pour toute l’équipe ?', 'Publiceren voor het hele team?', 'Publish to the whole team?'),
  yes:        L('Oui', 'Ja', 'Yes'),
  cancel:     L('Annuler', 'Annuleren', 'Cancel'),
  edit:       L('Modifier', 'Bewerken', 'Edit'),
  save:       L('Enregistrer', 'Opslaan', 'Save'),
  saving:     L('Enregistrement…', 'Opslaan…', 'Saving…'),
  discard:    L('Annuler les modifications', 'Wijzigingen annuleren', 'Discard changes'),
  unsaved:    L('Modifications non enregistrées', 'Niet-opgeslagen wijzigingen', 'Unsaved changes'),
  saveFailed: L('L’enregistrement a échoué. Réessayez.', 'Opslaan is mislukt. Probeer opnieuw.', 'Saving failed. Try again.'),
  attachment: L('Fichier Excel joint', 'Bijgevoegd Excel-bestand', 'Attached Excel file'),
  noAttach:   L('Aucun fichier joint', 'Geen bijlage', 'No attachment'),
  attachNew:  L('Joindre une nouvelle version', 'Nieuwe versie bijvoegen', 'Attach a new version'),
  alsoImport: L('Remplacer aussi le contenu par celui du fichier', 'Ook de inhoud vervangen door die van het bestand', 'Also replace the content with the file’s'),
  importWarn: L('Les modifications faites ici seront remplacées (les seuils sont gardés).', 'Wijzigingen die hier gemaakt zijn, worden overschreven (de drempels blijven).', 'Edits made here will be replaced (thresholds are kept).'),
  newMap:     L('Nouvelle carte ou annexe', 'Nieuwe map of bijlage', 'New map or annex'),
  newName:    L('Nom (ex. Logistique)', 'Naam (bv. Logistiek)', 'Name (e.g. Logistics)'),
  createBlank:L('Créer (vide)', 'Aanmaken (leeg)', 'Create (blank)'),
  createXlsx: L('Créer depuis un Excel', 'Aanmaken vanuit Excel', 'Create from Excel'),
  rename:     L('Nom de l’onglet', 'Naam van het tabblad', 'Tab name'),
  deleteMap:  L('Supprimer cette carte', 'Deze map verwijderen', 'Delete this map'),
  confirmDel: L('Supprimer définitivement ?', 'Definitief verwijderen?', 'Delete for good?'),
  busy:       L('Un instant…', 'Even geduld…', 'One moment…'),
  empty:      L('La career map n’est pas encore disponible.', 'De career map is nog niet beschikbaar.', 'The career map isn’t available yet.'),
  emptyHr:    L('Aucune carte pour l’instant.', 'Nog geen map.', 'No map yet.'),
  failed:     L('Le chargement a échoué. Rechargez la page.', 'Laden is mislukt. Herlaad de pagina.', 'Loading failed. Reload the page.'),
  nav: {
    overview: L('Vue d’ensemble', 'Overzicht', 'Overview'),
    levels:   L('Niveaux', 'Niveaus', 'Levels'),
    compare:  L('Comparer', 'Vergelijken', 'Compare'),
    prepare:  L('Préparer mon entretien', 'Mijn gesprek voorbereiden', 'Prepare my review'),
    rules:    L('Règles & échelle', 'Regels & schaal', 'Rules & scale'),
    grid:     L('Grille complète', 'Volledige grille', 'Full grid'),
  },
  mapNames: {
    general: L('Général', 'Algemeen', 'General'),
    support: L('Support Client', 'Klantenservice', 'Customer support'),
  },
  stagesTitle: L('Quatre étapes', 'Vier stappen', 'Four stages'),
  journeyTitle:L('Le parcours', 'Het traject', 'The path'),
  journeyNote: L('Cliquez sur un niveau pour voir ce qui est attendu.', 'Klik op een niveau om te zien wat er verwacht wordt.', 'Click a level to see what it expects.'),
  managerOpt:  L('Piste manager optionnelle', 'Optioneel managerstraject', 'Optional manager track'),
  dualTrack:   L('Deux voies équivalentes', 'Twee gelijkwaardige sporen', 'Two equal tracks'),
  explore:     L('Explorer les niveaux', 'Niveaus verkennen', 'Explore the levels'),
  levelsWord:  L('niveaux', 'niveaus', 'levels'),
  nextStep:    L('Prochaine étape', 'Volgende stap', 'Next step'),
  toLevel:     L('Vers le niveau', 'Naar niveau', 'To level'),
  simulate:    L('Simuler cette étape', 'Deze stap simuleren', 'Simulate this step'),
  allTopics:   L('Tout', 'Alles', 'All'),
  keysHint:    L('Astuce : ← et → pour changer de niveau', 'Tip: ← en → om van niveau te wisselen', 'Tip: ← and → to switch levels'),
  swap:        L('Inverser', 'Omwisselen', 'Swap'),
  nextPair:    L('Paire suivante', 'Volgend paar', 'Next pair'),
  showMore:    L('Voir plus', 'Meer tonen', 'Show more'),
  showLess:    L('Voir moins', 'Minder tonen', 'Show less'),
  transitions: L('Les passages de niveau', 'De overgangen', 'Moving up, step by step'),
  transNote:   L('Ce qu’il faut pour chaque passage, d’après les règles ci-dessous.', 'Wat elke overgang vraagt, volgens de regels hieronder.', 'What each move takes, per the rules below.'),
  evalCount:   L('{n} éval.', '{n} eval.', '{n} review(s)'),
  inStage:     L('Dans l’étape', 'Binnen de stap', 'Within a stage'),
  expected:    L('Ce qui est attendu pour monter', 'Wat er verwacht wordt om door te groeien', 'What it takes to move up'),
  documents:   L('Documents', 'Documenten', 'Documents'),
  download:    L('Télécharger', 'Downloaden', 'Download'),
  addDoc:      L('Ajouter un document', 'Document toevoegen', 'Add a document'),
  removeDoc:   L('Retirer', 'Verwijderen', 'Remove'),
  views: {
    path:    L('Parcours', 'Traject', 'Path'),
    compare: L('Comparer', 'Vergelijken', 'Compare'),
    grid:    L('Grille complète', 'Volledige grille', 'Full grid'),
    sim:     L('Simulateur', 'Simulator', 'Simulator'),
  },
  level:      L('Niveau', 'Niveau', 'Level'),
  shared:     L('Commun aux niveaux', 'Gemeenschappelijk voor niveaus', 'Shared by levels'),
  from:       L('De', 'Van', 'From'),
  to:         L('À', 'Naar', 'To'),
  rules:      L('Règles de progression', 'Regels om door te groeien', 'Progression rules'),
  scale:      L('Échelle d’évaluation', 'Evaluatieschaal', 'Rating scale'),
  comps:      L('Compétences clés', 'Kerncompetenties', 'Key competencies'),
  addRow:     L('Ajouter une ligne', 'Rij toevoegen', 'Add a row'),
  addRule:    L('Ajouter une règle', 'Regel toevoegen', 'Add a rule'),
  addComp:    L('Ajouter une compétence', 'Competentie toevoegen', 'Add a competency'),
  addGroup:   L('Ajouter un groupe', 'Groep toevoegen', 'Add a group'),
  addItem:    L('Ajouter un critère', 'Criterium toevoegen', 'Add a criterion'),
  addCell:    L('Ajouter un texte pour ce niveau', 'Tekst voor dit niveau toevoegen', 'Add text for this level'),
  split:      L('Séparer par niveau', 'Per niveau splitsen', 'Split per level'),
  mergeNext:  L('Fusionner avec le suivant', 'Samenvoegen met volgende', 'Merge with next'),
  rowLabel:   L('Intitulé de la ligne', 'Titel van de rij', 'Row label'),
  floorRule:  L('Règle de plancher', 'Plancherregel', 'Floor rule'),
  scaleNote:  L('Note sur l’échelle', 'Opmerking bij de schaal', 'Note on the scale'),
  thresholds: L('Seuils du simulateur', 'Drempels van de simulator', 'Simulator thresholds'),
  evalForm:   L('Fiche d’évaluation', 'Evaluatiefiche', 'Review form'),
  step:       L('Passage', 'Overgang', 'Move'),
  evaluations:L('Évaluations', 'Evaluaties', 'Reviews'),
  approvalLbl:L('Validation', 'Goedkeuring', 'Approval'),
  floorLbl:   L('Note minimale', 'Minimumscore', 'Minimum score'),
  alertAvg:   L('Alerte si moyenne ≤', 'Alert als gemiddelde ≤', 'Alert if average ≤'),
  alertScore: L('Alerte si une note =', 'Alert als een score =', 'Alert if a score ='),
  leaderFrom: L('Leadership noté dès le niveau', 'Leadership gescoord vanaf niveau', 'Leadership scored from level'),
  months:     L('Mois entre deux évaluations', 'Maanden tussen evaluaties', 'Months between reviews'),
  optionalGrp:L('optionnel', 'optioneel', 'optional'),
  simIntro:   L('Simulez une évaluation : choisissez le niveau actuel et une note par compétence. Rien n’est enregistré, et la décision se prend toujours lors de l’entretien.',
                'Simuleer een evaluatie: kies het huidige niveau en een score per competentie. Er wordt niets bewaard, en de beslissing valt altijd tijdens het gesprek.',
                'Simulate a review: pick the current level and a score per competency. Nothing is saved, and the decision is always made in the review itself.'),
  current:    L('Niveau actuel', 'Huidig niveau', 'Current level'),
  average:    L('Score moyen', 'Gemiddelde score', 'Average score'),
  scored:     L('compétences notées', 'competenties gescoord', 'competencies scored'),
  toNext:     L('Pour passer au niveau', 'Naar niveau', 'To move to level'),
  avgNeed:    L('Moyenne ≥', 'Gemiddelde ≥', 'Average ≥'),
  evals1:     L('sur 1 évaluation', 'op 1 evaluatie', 'on 1 review'),
  evalsN:     L('sur {n} évaluations consécutives ({m} mois)', 'op {n} opeenvolgende evaluaties ({m} maanden)', 'on {n} consecutive reviews ({m} months)'),
  floorOk:    L('Aucune compétence sous {f}', 'Geen enkele competentie onder {f}', 'No competency below {f}'),
  approval:   {
    manager: L('Accord du manager', 'Akkoord van de manager', 'Manager’s agreement'),
    direction: L('Validation de la direction', 'Goedkeuring van de directie', 'Management approval'),
    'manager+direction': L('Accord du manager + validation de la direction', 'Akkoord manager + goedkeuring directie', 'Manager’s agreement + management approval'),
  },
  stageChange:L('Changement d’étape', 'Nieuwe stap', 'Stage change'),
  terminal:   L('C’est le niveau terminal de la filière.', 'Dit is het eindniveau van de loopbaan.', 'This is the top of the track.'),
  alert:      L('Plan d’accompagnement à prévoir dans le mois (score moyen ≤ {a} ou une compétence à {s}).', 'Begeleidingsplan binnen de maand nodig (gemiddelde ≤ {a} of een competentie op {s}).', 'A support plan is due within a month (average ≤ {a} or a competency at {s}).'),
  scoreAll:   L('Notez toutes les compétences pour voir le résultat.', 'Scoor alle competenties om het resultaat te zien.', 'Score every competency to see the result.'),
  met:        L('atteint', 'gehaald', 'met'),
  notMet:     L('pas encore', 'nog niet', 'not yet'),
  tip:        L('Astuce', 'Tip', 'Tip'),
  translations: L('Traductions', 'Vertalingen', 'Translations'),
  translate:  L('Traduire ce qui manque', 'Ontbrekende vertalen', 'Translate what’s missing'),
  retranslate:L('Tout retraduire', 'Alles opnieuw vertalen', 'Retranslate everything'),
  translating:L('Traduction', 'Vertalen', 'Translating'),
  translateFailed: L('La traduction a échoué. Réessayez.', 'Vertalen is mislukt. Probeer opnieuw.', 'Translation failed. Try again.'),
  editIn:     L('Textes en', 'Teksten in', 'Texts in'),
  editInNote: L('Vous modifiez la traduction. La structure (lignes, cellules, critères) se modifie pour toutes les langues ; les seuils restent communs.',
                'Je bewerkt de vertaling. De structuur (rijen, cellen, criteria) wijzigt voor alle talen; de drempels zijn gemeenschappelijk.',
                'You’re editing the translation. Structure (rows, cells, criteria) changes for every language; thresholds are shared.'),
};

export const tr = (o, locale, vars = {}) => {
  let s = (o && (o[locale] ?? o.fr)) || '';
  Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
  return s;
};

